module.exports = __webpack_public_path__ + "static/lidia-4f6d3d2c226bc713cc6d185cd528938f.png";